import * as qs from '@/ui/queryState';
import { endsToday, startsLast30Days } from '@/ui/helpers/dateHelper';

export const useQueryFiltering = () => ({
  start: qs.date('start', startsLast30Days()),
  end: qs.date('end', endsToday()),
  entityItem: qs.numbers('entityItem', []),
  entityFolder: qs.strings('entityFolder', []),
  group: qs.numbers('group', []),
  inspector: qs.numbers('inspector', []),
  category: qs.numbers('category', []),
  checklist: qs.numbers('checklist', []),
  questionTitle: qs.strings('questionTitle', []),
  response: qs.strings('response', []),
  inspection: qs.numbers('inspection', []),
  section: qs.strings('section', []),
  question: qs.strings('question', []),
});
